import { MATOMO_ID_HEX_LEN } from './matomo-analytics.config';

/** Generate a random 16-byte (32 hex char) session id. */
export function makeRandomSessionId(): string {
  const arr = new Uint8Array(16);
  globalThis.crypto.getRandomValues(arr);
  return Array.from(arr)
    .map(b => b.toString(16).padStart(2, '0'))
    .join('');
}

/** FNV-1a 64-bit hash as hex string (16 chars). Deterministic fallback when SHA-256 is unavailable. */
export function fnv1a64Hex(input: string): string {
  try {
    const encoder = new TextEncoder();
    const bytes = encoder.encode(input);
    let h = 14695981039346656037n;
    const prime = 1099511628211n;
    const mask = (1n << 64n) - 1n;
    for (const b of bytes) {
      h = (h ^ BigInt(b)) * prime;
      h &= mask;
    }
    return h.toString(16).padStart(16, '0').slice(0, 16);
  } catch {
    const arr = new Uint8Array(8);
    globalThis.crypto.getRandomValues(arr);
    return Array.from(arr)
      .map(b => b.toString(16).padStart(2, '0'))
      .join('');
  }
}

/** Compute matomo_id from host+sessionId+embedded via SHA-256, with FNV fallback. */
export async function computeMatomoId(
  hostKey: string,
  sessionId: string,
  embeddedSuffix: string
): Promise<string> {
  const input = `${hostKey}${sessionId}${embeddedSuffix}`;
  try {
    const enc = new TextEncoder();
    const digest = await globalThis.crypto.subtle.digest('SHA-256', enc.encode(input));
    const bytes = new Uint8Array(digest);
    const hex = Array.from(bytes)
      .map(b => b.toString(16).padStart(2, '0'))
      .join('');
    return hex.slice(0, MATOMO_ID_HEX_LEN);
  } catch {
    return fnv1a64Hex(input);
  }
}
